import React, {useCallback, useContext} from 'react';
import cx from 'classnames';
import {OverviewCardsList} from './OverviewCardsList';
import {AutomationOverviewHeader} from './AutomationOverviewHeader';
import {RuleType} from '../../../../enums';
import {AIAskBlock} from '../../../common/AIAskBlock/AIAskBlock';
import styles from '../../styles.module.scss';
import {AutomationsOverviewContext} from '../../RulesListDialog';
import {AIRulesMonitoring} from '../../../common/AIAskBlock/enums';
import {monitorAction} from '../../../../../../services/datadog';
import {getRuleKeyByValue} from '../../../../utils';

export const AutomationsOverview = ({type, session}: {type: RuleType; session: string}) => {
    const [showAI, setShowAI] = React.useState(false);
    const {toggleKeyboardInteraction} = useContext(AutomationsOverviewContext);

    const onAIInputFocus = useCallback(
        () => toggleKeyboardInteraction(true),
        [toggleKeyboardInteraction]
    );

    const onAIInputBlur = useCallback(
        () => toggleKeyboardInteraction(false),
        [toggleKeyboardInteraction]
    );

    const onAIClick = () => {
        if (!showAI) {
            // send datadog event only when AI is opened
            monitorAction(AIRulesMonitoring.showAI, {ruleType: getRuleKeyByValue(type)});
        }
        setShowAI(!showAI);
    };

    return (
        <div className={cx('reactComp', styles.rulesOverview)}>
            <AutomationOverviewHeader onAIClick={onAIClick} />

            {showAI ? (
                <AIAskBlock
                    onAIInputFocus={onAIInputFocus}
                    onAIInputBlur={onAIInputBlur}
                    componentClasses={styles.aiAskBlock}
                    maxWidth={700}
                    type={type}
                    session={session}
                />
            ) : (
                <OverviewCardsList type={type} session={session} />
            )}
        </div>
    );
};
